import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

import { LottiePlayer } from '@repo/design-system-kit';

import styles from './styles.module.css';

export default class RegistrationPricePlanErrorController extends Controller {
  lottiePlayer = LottiePlayer;

  @service router;

  @action
  refreshRoute() {
    this.router.transitionTo('registration.price-plans');
  }
  styles = styles;
}
